import { Package } from 'lucide-react'

import type { Product } from '@/lib/api/product-api'
import { formatQty, formatVND } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'
import { getProductImageURL } from '@/lib/product-image'

interface Props {
    product: Product
    /** Tồn khả dụng theo warehouse mặc định. undefined = chưa biết, không show. */
    stock?: number
    onClick: (product: Product) => void
}

export function PosProductCard({ product, stock, onClick }: Props) {
    const primaryImg =
        product.images?.find((i) => i.is_primary) ?? product.images?.[0]

    return (
        <button
            type="button"
            onClick={() => onClick(product)}
            className="flex flex-col items-center gap-1 rounded-lg border bg-card p-2 text-center hover:border-primary/60 hover:shadow-sm transition-all cursor-pointer"
        >
            <div className="size-14 rounded bg-muted flex items-center justify-center shrink-0 overflow-hidden">
                {primaryImg ? (
                    <img
                        src={getProductImageURL(primaryImg.image_url)}
                        alt={product.name}
                        className="size-full object-cover"
                        loading="lazy"
                    />
                ) : (
                    <Package className="size-6 text-muted-foreground" />
                )}
            </div>
            <span className="text-xs font-medium leading-tight line-clamp-2 w-full">
                {product.name}
            </span>
            <span className="text-xs text-primary font-semibold">
                {formatVND(product.unit_price)}
            </span>
            {typeof stock === 'number' ? (
                <span
                    className={
                        stock > 0
                            ? 'text-[10px] leading-none px-1.5 py-0.5 rounded-full bg-emerald-100 text-emerald-700'
                            : 'text-[10px] leading-none px-1.5 py-0.5 rounded-full bg-destructive/10 text-destructive'
                    }
                >
                    {m.order_product_stock_badge({
                        qty: formatQty(stock),
                        unit: product.unit,
                    })}
                </span>
            ) : (
                product.unit && (
                    <span className="text-[10px] leading-none px-1.5 py-0.5 rounded-full bg-muted text-muted-foreground">
                        {product.unit}
                    </span>
                )
            )}
        </button>
    )
}
